/**
 * ToolbarSearchField — 목록 화면 헤더의 표준 검색 필드.
 *
 * Workspaces 픽커의 검색 모양(둥근 action.hover 배경·무테두리·좌측 돋보기)을
 * 기준으로 추출 (2026-08-12 L&F 통일). Workspaces·Simulations 가 같은
 * 컴포넌트를 쓰므로 두 화면의 검색이 구조적으로 같은 모양을 유지한다.
 */

import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface ToolbarSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** 기본 300px — 픽커 기준 */
  width?: number | string;
}

const ToolbarSearchField: React.FC<ToolbarSearchFieldProps> = ({
  value,
  onChange,
  placeholder,
  width = 300,
}) => (
  <TextField
    placeholder={placeholder}
    size="small"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{
      width,
      // 좁은 화면에서 고정폭이 헤더 가로 오버플로우를 만들지 않게 (리뷰 반영)
      maxWidth: '100%',
      bgcolor: 'action.hover',
      borderRadius: 1,
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon color="action" />
        </InputAdornment>
      ),
    }}
    // placeholder 는 입력하면 사라지는 시각 힌트 — 보조기술용 지속 이름 별도 (리뷰 반영)
    inputProps={{ 'aria-label': placeholder }}
  />
);

export default ToolbarSearchField;
